const env = {
    //API_HOST: 'http://localhost:3001',
    API_HOST: 'https://doczaira.ru/api',
};

export default env;